const BACKEND_URL = import.meta.env.DEV ? "http://localhost:7071" : import.meta.env.VITE_BACKEND_URL;
export const routes = {
  openai: `${BACKEND_URL}/api/openai`,
  translate: `${BACKEND_URL}/api/translate`,
  history: `${BACKEND_URL}/api/history`,
  feedback: `${BACKEND_URL}/api/feedback`
}
